<div class="guideline-container" *ngIf="guideLine">
    <p class="guideline" [class.max-width-500]="guideLine.length > 250">{{ guideLine }}</p>
    <img src="./../../../assets/img/sadey_tooltip_i.svg">
</div>